/* Up selectコンシェルジュ ─ 入口と、会話の窓

   ⚠️ 既存のDOMには一切触らない。body の末尾に自分の要素を足すだけ。
   ⚠️ 二重に動かない。⚠️ 固定フッターがある面では床を上げる。
   答えの組み立ては upc-router.js（window.UPC）。知識は upc-kb.js。
*/
(function () {
  'use strict';
  if (window.__upcBooted) return;
  window.__upcBooted = true;

  var CY = 8000;
  /* ⚠️ お店で、いきなり返品の話はしない。**入口は買う前の相談**にする（260807 Take）。
     返品や配送は、聞かれたら答える。入口には出さない。 */
  /* ★呼びかけが「サイズ・素材」だと、**受けられる幅が狭いと伝わる**（260809・Take）。
     お店の人の第一声に寄せる＝何を探しているかを、一緒に決めるところから */
  var SAYS = ['お探しのもの、ご一緒に選びます',
              '似合う色もお出しできます',
              '着ているところも見られます'];
  /* ★カートの面は、素材やサイズの迷いではない＝**買う直前に気になること**に応える
     （260809・Take「カートは素材・サイズの悩みではないから、購入直前で気になる点に
     応えるさまに吹き出しを変えて」）。中身は入口のボタンと同じ4つ */
  var SAYS_CART = ['お届けの日のこと、お答えします',
                   '送料やお支払い方法のことも',
                   '返品のこともご案内できます'];
  var SUB = '<small>AIがその場でお答えします</small>';
  /* ★呼びかけは**一度出したら、しばらく出さない**（260809・Take「ページ変わるたびに
     毎回開くのうっとうしい。いっかい開いたら一定期間は開かない様に。アイコンだけが出る」）。
     ひと回り（3つ）出したら控えを置き、24時間は**丸だけ**にする。
     窓を開けていただけたなら、もうご存じなので同じく控える。 */
  var SAY_SEEN = 'upc.say.v1';
  var SAY_QUIET_H = 24;
  /* 丸と吹き出しに出す up のマーク。ヘッダーのロゴ（logo_0.png）から橙の「up」だけを
     切り出して焼き込んである。⚠️ 外のURLを見に行かない＝テーマのアセットを増やさず、
     ロゴが差し替わっても黙って消えない。切り出しの手順は README §9。*/
  var MARK = 'data:image/png;base64,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';
  var STORE = 'upc.log.v1';
  var KEEP_DAYS = 90;

  /* 呼びかけを控えるかどうか。⚠️ localStorage が使えない端末でも落ちない */
  function sayQuiet() {
    try {
      var t = parseInt(localStorage.getItem(SAY_SEEN) || '0', 10);
      return t > 0 && Date.now() - t < SAY_QUIET_H * 36e5;
    } catch (e) { return false; }
  }
  function markSaySeen() {
    try { localStorage.setItem(SAY_SEEN, String(Date.now())); } catch (e) { /* 無視 */ }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  /* 3桁区切り。⚠️ upc-router.js の yen と同じ形にする（値段の見た目がずれる） */
  function yen(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /* ── 端末のなかに会話を残す（ログイン不要・90日で消える）───────── */
  function load() {
    try {
      var d = JSON.parse(localStorage.getItem(STORE) || '{}');
      if (!d.at || Date.now() - d.at > KEEP_DAYS * 864e5) return [];
      return d.turns || [];
    } catch (e) { return []; }
  }
  function save(turns) {
    try {
      localStorage.setItem(STORE, JSON.stringify({at: Date.now(), turns: turns.slice(-40)}));
    } catch (e) { /* 容量やプライベートモードでは残さない */ }
  }
  function forget() {
    try { localStorage.removeItem(STORE); } catch (e) {}
  }

  /* 床に貼り付いている帯の高さ。丸をそこに重ねない。
     ⚠️ **クラス名で探さない**＝帯は面ごとに別物（PDPは .sticky-footer-container、
     カートは購入手続きの帯）で、名前で書くと知らない面で必ず重なる。
     いちばん下の画素に実際に何が置かれているかを見る（elementsFromPoint は1回で済む）。
     ⚠️ 帯は**出たり消えたりする**（スクロールで class が付く）ので一度きりにしない。 */
  function barHeight() {
    var best = 0;
    var xs = [innerWidth * 0.5, innerWidth * 0.2, innerWidth * 0.8];
    for (var i = 0; i < xs.length; i++) {
      var stack = document.elementsFromPoint(xs[i], innerHeight - 3) || [];
      for (var j = 0; j < stack.length; j++) {
        var e = stack[j];
        if (!e.closest || e.closest('.upc-fab,.upc-panel')) continue;
        if (getComputedStyle(e).position !== 'fixed') continue;
        var b = e.getBoundingClientRect();
        /* 全画面の幕（拡大写真・メニュー）は床ではない。細い印も帯ではない */
        if (b.height < 20 || b.height > 160 || b.width < innerWidth * 0.5) continue;
        if (b.height > best) best = b.height;
        break;
      }
    }
    return Math.round(best);
  }

  ready(function () {
    if (document.querySelector('.upc-fab')) return;

    var logo = window.__upcLogo || MARK;
    var fab = el('button', 'upc-fab');
    fab.type = 'button';
    fab.setAttribute('aria-label', 'Up selectコンシェルジュに聞く');
    fab.innerHTML = '<span class="upc-mark">'
      + (logo ? '<img src="' + logo + '" alt="">' : '')
      + '<i class="upc-dot"></i></span><span class="upc-say"></span>';

    var panel = el('div', 'upc-panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Up selectコンシェルジュ');
    panel.innerHTML =
      /* ★見出しとそえ書きを1つの器に入れる＝狭いときに**そえ書きだけ**が2行目へ回る。
         器が無いと、×まで2行目に落ちる（フレックスは並び順のまま折り返す） */
      '<div class="upc-bar"><span class="upc-name">'
      + '<b>Up selectコンシェルジュ</b><i>自動でお答えします</i></span>'
      + '<button class="upc-close" type="button" aria-label="閉じる">×</button></div>'
      /* ★いま何について話しているかを、**常に見えるところに出す**（260809・Take
         「今何を対象範囲にして応答してるか分からん」）。商品ページでは
         その一枚、それ以外はお店全体。押せば話す相手を変えられる */
      + '<div class="upc-scope"></div>'
      + '<div class="upc-log"></div>'
      + '<div class="upc-foot">'
      + '<div class="upc-chips"></div>'
      + '<form class="upc-form"><input class="upc-input" type="text" '
      + 'placeholder="どんな服をお探しですか" aria-label="ご質問">'
      + '<button class="upc-send" type="submit">送る</button></form>'
      + '<button class="upc-forget" type="button">これまでのやりとりを消す</button>'
      /* お預かりするものを、その場に書いておく（探しに行かせない） */
      + '<p class="upc-privacy">いただいたご質問は、品ぞろえと商品ページの改善に'
      + '使わせていただきます。お名前・ご連絡先は送信されません。</p>'
      + '</div>';

    document.body.appendChild(fab);
    document.body.appendChild(panel);

    /* 床の帯の上に置き直す。**測るのは貼ってから**（貼る前は幅も高さも取れない） */
    var placedAt = -1;
    function place() {
      var h = barHeight();
      if (h === placedAt) return;
      placedAt = h;
      var b = (h ? h + 40 : 40) + 'px';
      fab.style.bottom = b;
      panel.style.bottom = b;
    }
    var placing = 0;
    function placeSoon() {
      if (placing) return;
      placing = setTimeout(function () { placing = 0; place(); }, 200);
    }
    place();
    addEventListener('scroll', placeSoon, {passive: true});
    addEventListener('resize', placeSoon);
    /* テーマとアプリの帯は遅れて出る。数秒のあいだ見張る */
    [400, 1200, 2500, 5000].forEach(function (ms) { setTimeout(place, ms); });

    var log = panel.querySelector('.upc-log');
    var scope = panel.querySelector('.upc-scope');
    var chips = panel.querySelector('.upc-chips');
    var turns = load();

    /* ★話している対象を出し直す。**答えるたびに更新する**（黙って変わらない） */
    function paintScope() {
      var h = (ctx && (ctx.product || ctx.page)) || '';
      var p = null, i;
      for (i = 0; h && i < window.UPC.KB.products.length; i++) {
        if (window.UPC.KB.products[i].h === h) p = window.UPC.KB.products[i];
      }
      if (p) {
        var name = p.t.replace(/【.*?】/g, '').trim();
        scope.innerHTML = '<span class="upc-scope-t">いまの話：<b>'
          + esc(name) + '</b></span>'
          + '<button type="button" data-ask="ほかのものも見せてください">ほかの商品も</button>';
      } else if (/^\/cart(\/|$)/.test(location.pathname)) {
        /* ★カートは会計の話。ここから探しものへ戻す道は置かない（260809・Take） */
        scope.innerHTML = '<span class="upc-scope-t">いまの話：<b>お会計のこと</b></span>';
      } else if (collName()) {
        /* ★コレクションでは、その並びの名前を出す（260809・Take「商品名、コレクション、
           カートとかに切り替える必要がある」）。押せば**その中から**お探しする */
        /* ⚠️ 260810まで**一覧の名前をそのまま探し言葉にして送っていた**。
           名前の中の言葉が別の用件に当たり、33面のうち9面で壊れていた
           （「お客様の評価が高いアイテム」→評判／「定番パンツの着回しに！」→合わせ方／
           「夏に着たい！上品&着痩せノースリーブ3選」→**この一覧には無いと言って
           店ぜんぶへ広げる**）。**送る言葉は名前に依らない一言にする**。
           ⚠️ 名前は見出しに出ているので、送る文に入れる必要はない */
        scope.innerHTML = '<span class="upc-scope-t">いまの話：<b>'
          + esc(collName()) + '</b></span>'
          + '<button type="button" data-ask="この一覧から選びたいです">'
          + 'この中から選ぶ</button>';
      } else {
        /* ★お店ぜんぶのときは、**お店そのものの話**にも入れるようにする
           （260809・Take「Up selectについて、も入れて欲しい」） */
        /* ⚠️ ボタンを2つ置いたら、**「いまの話：お・・・」と文字が潰れた**（260809・Take）。
           帯は1行しかないので、置けるボタンは**1つだけ**。
           「商品をえらぶ」は入口の丸の1つめ（合う一枚を選んで）に同じ道がある */
        scope.innerHTML = '<span class="upc-scope-t">いまの話：<b>お店ぜんぶから</b></span>'
          /* ⚠️ 320pxでは「Up selectについて」（12字）でも文字が潰れる（実測）。
             帯のボタンは**短い言葉**にする。入口の丸のほうは長いままでよい */
          + '<button type="button" data-ask="Up selectってどんなお店ですか">'
          + 'お店のこと</button>';
      }
    }

    /* いま見ているコレクションの名前。
       ★260810＝**名前を出してよい面かどうかは router に訊く**（`collInfo`）。
         帯に「いまの話：羽織り・ジャケット」と出しておきながら、答えは店ぜんぶ……
         という食い違いが、この面のバグの正体だった（Take）。
       ⚠️ 見出し（h1）は控えの手段。見出しは「コレクション: トップス」の形（実測）で、
          すべてのアイテムは名前が「商品」なので、店ぜんぶ扱いにする */
    function collName() {
      if (!/^\/collections\//.test(location.pathname)) return '';
      var info = window.UPC && window.UPC.collInfo
               && window.UPC.collInfo(collHandle);
      if (info) return info.t.slice(0, 18);
      return '';
    }

    /* 会話の文脈。**いま見ている商品ページを既定にする**＝「いくら？」だけで通じる */
    var pageHandle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
    /* ★いま見ているコレクション（260810・Take「羽織ジャケットで人気のものを押すと、
       ジョガーパンツとか関係ないのが出る」）。**この中からお出しする**。
       ⚠️ 見出し（h1）ではなくURLのhandleで見る＝見出しの書き方に左右されない */
    var collHandle = (location.pathname.match(/\/collections\/([^/?#]+)/) || [])[1] || '';
    var ctx = window.UPC ? window.UPC.newCtx(pageHandle, collHandle) : null;
    /* ★カートの面では、決済へ進む後押しを優先する（260809・Take） */
    if (ctx && /^\/cart(\/|$)/.test(location.pathname)) ctx.at = 'cart';
    /* ★前回の話に出た商品は、**同じ商品ページにいるときだけ**引き継ぐ（260809・Take
       「PDPからトップやコレクションに飛ぶと、今の話がPDPのまま引き継がれるから
       会話が切りかわらん」）。面が変わったら、話す相手も変わる。 */
    if (ctx && pageHandle && turns.length
        && turns[turns.length - 1].product === pageHandle) {
      ctx.product = pageHandle;
    }

    /* ── 描く ───────────────────────────────────────── */
    function me(text) {
      var b = el('div', 'upc-me', esc(text));
      log.appendChild(b);
    }
    function bot(a) {
      var h = '<span class="upc-flag ' + (a.tier === '🟢' ? 'g' : a.tier === '🟡' ? 'y' : 'r')
            + '">' + (a.tier === '🟢' ? 'そのまま答える'
                     : a.tier === '🟡' ? 'わかるところまで' : '人にお渡しする') + '</span>';
      /* ★何についての答えかを、**答えより先に、写真つきで**置く（260809・Take
         「今何を対象にトークしているかがやや分かりにくい。上に書いてあるのは分かるが」）。
         ⚠️ 商品の写真を出す答え（提案・探した結果）には付けない＝二重になる */
      if (a.about && a.about.t) {
        h += '<a class="upc-about" href="/products/' + esc(a.about.h) + '">'
           + (a.about.img ? '<img src="' + esc(a.about.img) + '" alt="" loading="lazy">' : '')
           + '<span>' + esc(a.about.t) + '<i>について</i></span></a>';
      }
      h += '<p class="upc-lead">' + esc(a.lead) + '</p>';
      // 表になる行（「◯◯：…（残りN点）」）は表で出し、**それ以外の文はそのまま出す**。
      // ここを落とすと、推した理由と「合わなければ交換できます」が消える
      var cardT = (a.cards || []).map(function (c) {
        return c.t + '／' + yen(c.p) + '円';
      });
      var prose = a.body.filter(function (t) {
        /* ⚠️ 「（残り◯点）」で見分けていたので、点数をやめた途端に
           **サイズ表の行が文としても出る**ようになっていた（260809・Take）。
           見分けは「◯：実寸／実寸…」の形そのもので取る */
        if (/^[^：]{1,12}：[^：]*(cm|\d)/.test(t) && a.rows && a.rows.length) return false;
        if (/：.*（残り\d+点）$/.test(t)) return false;                 // 旧・サイズ表の行
        if (/^[^：]{1,12}：.*（品切れ）$/.test(t)) return false;         // サイズ表の行（品切れ）
        if (a.colors && a.colors.length
            && /^[^：]{1,10}：品切れです$/.test(t)) return false;            // 色の行
        if (cardT.indexOf(t) >= 0) return false;   // 写真のカードに出ている行
        return true;
      });
      h += prose.map(function (t) { return '<p>' + esc(t) + '</p>'; }).join('');
      if (a.rows && a.rows.length) {
        /* ★★サイズ表に**在庫の列を出さない**（260809・Take「サイズ表に在庫数を
           表示しない様に」）。⚠️ 文のほうから「残り◯点」を消しても、
           **表はここで自前の在庫列を作っていた**ので消えていなかった。
           品切れのサイズだけ、いちばん右に「品切れ」と書く */
        h += '<table class="upc-tbl"><tr><th></th>'
           + a.rows[0].z.slice(0, 3).map(function (x) { return '<th>' + esc(x[0]) + '</th>'; }).join('')
           + '</tr>'
           + a.rows.map(function (v) {
               /* 全色そろって在庫が無ければ「品切れ」、一部の色だけなら
                  **その色の名前だけ**を小さく添える（数は出さない／260809・Take） */
               var so = ((v.s || 0) <= 0) ? '<i>品切れ</i>'
                 : ((v.out && v.out.length)
                     ? '<i>品切れ：' + esc(v.out.join('・')) + '</i>' : '');
               return '<tr><td class="h">' + esc(v.t) + so + '</td>'
                 + v.z.slice(0, 3).map(function (x) { return '<td>' + esc(x[1]) + '</td>'; }).join('')
                 + '</tr>';
             }).join('') + '</table>';
      }
      // 色は写真で。文の行（「コン：残り42点」）は畳む
      if (a.colors && a.colors.length) {
        /* ★写真1枚ずつが、その商品への入口（260809・Take）。
           ⚠️ alt に色名を入れると、写真が出ないときに**名前が2回**見える */
        h += '<div class="upc-colors">' + a.colors.map(function (c) {
          var tag = c.h ? 'a' : 'figure';
          var at = c.h ? ' href="/products/' + esc(c.h) + '"' : '';
          return '<' + tag + at + ' class="upc-sw' + (c.stock ? '' : ' out') + '">'
               + (c.img ? '<img src="' + esc(c.img) + '" alt="" loading="lazy">' : '')
               + '<span><b>' + esc(c.name) + '</b>'
               + (c.stock ? '' : '<br>品切れ') + '</span></' + tag + '>';
        }).join('') + '</div>';
      }
      /* ★商品は写真でお出しする（260809・Take「写真はでないな。テキストベースでつまらん」）。
         文の行（「商品名／6,800円」）は畳む＝カードに名前も値段も入っている。
         ⚠️ 押せる先は商品ページ。カードが飾りにならないようにする */
      if (a.cards && a.cards.length) {
        h += '<div class="upc-cards' + (a.cards.length === 1 ? ' one' : '')
           + '">' + a.cards.map(function (c) {
          /* ★押したら**チャットの中でその一枚の話に切り替える**（260809・Take決定）。
             前は商品ページへのリンクで、押すと会話がそこで切れていた。
             商品ページへは、答えの中の「この商品を見る」からお進みいただく */
          return '<button type="button" class="upc-card" data-ask="'
               + esc(c.t) + 'はどんな商品ですか">'
               + (c.img ? '<img src="' + esc(c.img) + '" alt="" loading="lazy">' : '')
               + '<span class="upc-card-t">' + esc(c.t) + '</span>'
               + '<span class="upc-card-p">' + yen(c.p) + '円</span></button>';
        }).join('') + '</div>';
      }
      /* ★ガイドの図は、着用スナップと**縦横比が違う**（ロゴは横長153×50、説明の絵は
         460×467）。同じ枠（3:4で切り取り）で出すと84×112に潰れて読めなかった
         （260809・Take「ロゴ画像が変」）。**切り取らず、原寸比のまま**出す。
         ⚠️ 横長のものは印として小さく、四角いものは幅いっぱいに＝**読める大きさ**に。
            見分けは、絵が読み込めたところで naturalWidth/Height から決める */
      if (a.figs && a.figs.length) {
        h += '<div class="upc-figs">' + a.figs.map(function (s) {
          return '<figure><img src="' + esc(s.img) + '" alt="" loading="lazy">'
               + (s.txt ? '<figcaption>' + esc(s.txt) + '</figcaption>' : '')
               + '</figure>';
        }).join('') + '</div>';
      }
      if (a.snaps && a.snaps.length) {
        h += '<div class="upc-snaps">' + a.snaps.map(function (s) {
          return '<figure><img src="' + esc(s.img) + '" alt="">'
               + (s.txt ? '<figcaption>' + esc(s.txt) + '</figcaption>' : '')
               + '</figure>';
        }).join('') + '</div>';
      }
      // 写真に説明が付くので、同じ中身の一行は畳む（文だけの経路では残す）
      var notes = a.note.filter(function (t) {
        return !(a.snaps && a.snaps.length && t.indexOf('着ているところ：') === 0);
      });
      if (notes.length) {
        h += '<p class="upc-note">' + notes.map(esc).join('<br>') + '</p>';
      }
      if (a.acts.length) {
        h += '<div class="upc-acts">' + a.acts.map(function (x, i) {
          var cls = i === 0 ? 'upc-cta' : 'upc-sub';
          var label = esc(x[0]), kind = x[1], arg = x[2];
          if (kind === 'form') {
            return '<a class="' + cls + '" href="' + window.UPC.formUrl(a) + '">' + label + '</a>';
          }
          if (kind === 'url') {
            return '<a class="' + cls + '" href="' + esc(arg) + '">' + label + '</a>';
          }
          if (kind === 'mail') {
            return '<a class="' + cls + '" href="mailto:' + esc(arg) + '">' + label + '</a>';
          }
          if (kind === 'cart') {
            /* ★会話でサイズと色が決まったときだけ出る（260809・Take）。
               ⚠️ 押した先はカート投入。**番号は router が決めたものだけ**を使う */
            return '<button class="' + cls + ' upc-buy" type="button" data-cart="'
                 + esc(arg) + '">' + label + '</button>';
          }
          if (kind === 'pick') {
            /* ★いま見ている商品の「サイズと色を選ぶ」ところへご案内する（260809・Take
               「同一商品なら同じPDPに飛ぶだけ。CVを後押しする接客にしたい」） */
            return '<button class="' + cls + '" type="button" data-pick="1">'
                 + label + '</button>';
          }
          if (kind === 'diag') {
            // 商品ページにある「身長・体重からおすすめサイズ」を開く。
            // そのページに無ければ、商品ページへ送る
            return '<button class="' + cls + '" type="button" data-diag="'
                 + esc(arg) + '">' + label + '</button>';
          }
          return '<button class="' + cls + '" type="button" data-ask="'
               + esc(arg) + '">' + label + '</button>';
        }).join('') + '</div>';
      }
      /* 次に聞けること。**答えて終わりにしない**＝会話を戻す小さな手がかり。
         acts（買う・フォームへ）とは見た目を分けて、続きの話だと分かるようにする */
      if (a.next && a.next.length) {
        h += '<div class="upc-next"><span class="upc-next-h">つづけて</span>'
           + a.next.map(function (x) {
               return '<button class="upc-chip" type="button" data-ask="'
                    + esc(x[1]) + '">' + esc(x[0]) + '</button>';
             }).join('') + '</div>';
      }
      // 出典が無い返し（あいさつ・お礼）で、裸の「—」を出さない
      var src = a.sources.filter(function (s) { return s && s !== '—'; }).join('／');
      if (src) h += '<div class="upc-src">' + esc(src) + '</div>';
      log.appendChild(botTurn(h));
      /* ガイドの図は、読み込めたところで**横長か四角か**を見て大きさを決める */
      [].forEach.call(log.querySelectorAll('.upc-figs img'), function (im) {
        var mark = function () {
          if (!im.naturalWidth) return;
          /* ⚠️ 小さい絵を幅いっぱいに伸ばすとぼやける（JCBのマークは66×50）。
             **横長か、もともと小さいもの**は印として小さく出す */
          var wide = im.naturalWidth / im.naturalHeight > 1.8;
          im.parentNode.className = (wide || im.naturalWidth < 200) ? 'wide' : 'shot';
        };
        if (im.complete) mark(); else im.addEventListener('load', mark);
      });
      showLatest();
    }

    /* ★答えが出ても、いちばん下へ飛ばさない。
       下に飛ばすと**お客様が何を聞いたかが画面の外へ出て**、確かめるのに指で戻すことになる
       （260809にTake）。答えのいちばん大事なところ（結論の一行）も一緒に隠れる。
       so **お尋ねの頭を窓の上端にそろえる**＝質問と結論がいつも同時に見える。
       ⚠️ 短い答えのときは下端で止まる（ブラウザが勝手に丸めるので、こちらでは何もしない）。
       ⚠️ 一気に動かす。なめらかに動かすと、読み始める前に景色が流れる */
    function showLatest() {
      var qs = log.querySelectorAll('.upc-me');
      var q = qs.length ? qs[qs.length - 1] : null;
      if (!q) { log.scrollTop = log.scrollHeight; return; }
      log.scrollTop += q.getBoundingClientRect().top
                     - log.getBoundingClientRect().top - 8;
    }

    /* 吹き出しには up のマークを添える＝お店の言葉として読まれる */
    function botTurn(html) {
      var t = el('div', 'upc-turn');
      t.innerHTML = '<span class="upc-ava">'
        + (logo ? '<img src="' + logo + '" alt="Up select">' : '')
        + '</span>';
      t.appendChild(el('div', 'upc-bot', html));
      return t;
    }

    /* 答えられたか／渡したかを数える。**質問文は送らない**（端末の中だけ）。
       文が要るのは🟡🔴だけで、それはフォームに引き継ぐぶんが up_support へ届く。

       ⚠️ GA4は登録していないパラメータを読めない。いまのサービスアカウントは
          読み取りだけで登録できない（403）。そこで**すでに登録されている
          event_category / event_label に載せる**＝GA4の設定を触らずに読める。
          段（緑黄赤）はイベント名に埋める。 */
    function track(a) {
      try {
        if (typeof window.gtag !== 'function') return;
        var name = a.tier === '🟢' ? 'upc_ans_green'
                 : a.tier === '🟡' ? 'upc_ans_amber' : 'upc_ans_red';
        window.gtag('event', name, {
          event_category: a.intent,
          event_label: a.prefill ? 'to_form' : 'answered'
        });
      } catch (e) { /* 計測で画面を止めない */ }
    }

    /* 買う前のご相談を、品ぞろえの材料として残す（案(c)＝置き場所を1つ作る）。

       ★送る前に window.UPC.scrub() を通す＝**お名前・ご連絡先は端末を出ない**。
         身長やウエストは残す（それが材料そのもの。誰のものかは送らない）。
       ⚠️ 会話ごとの乱数だけを添える。会員IDもCookie IDも送らない。
       ⚠️ 送り先が無ければ何もしない（テーマ出しのあと、鍵を入れてから効く）。
       ⚠️ 計測で画面を止めない。返事は見ない（no-cors）。 */
    var SINK = (window.UPC_KB && window.UPC_KB.sink) || {};
    var sinkSent = 0;
    function sid() {
      try {
        var k = 'upc.sid', v = sessionStorage.getItem(k);
        if (!v) {
          v = String(Date.now() % 1e7) + '-' + Math.floor(Math.random() * 1e6);
          sessionStorage.setItem(k, v);
        }
        return v;
      } catch (e) { return ''; }
    }
    function sink(text, a) {
      try {
        if (!SINK.url || !SINK.key) return;
        /* ★落とし方の表が載っていなければ**送らない**。
           scrub は表が無いと素通り＝原文がそのまま出てしまう（開いたまま倒れない） */
        if (!window.UPC_KB.masks || !window.UPC_KB.masks.length) return;
        if (sinkSent >= (SINK.maxTurns || 30)) return;   // いたずら・暴走よけ
        sinkSent++;
        var body = JSON.stringify({
          k: SINK.key,
          s: sid(),
          pg: pageHandle || '',
          q: window.UPC.scrub(String(text)).slice(0, SINK.maxChars || 400),
          tier: a.tier,
          intent: a.intent,
          src: (a.sources || []).join('／').slice(0, 120),
          form: a.prefill ? 1 : 0
        });
        /* text/plain ＝ 事前確認(preflight)の要らない形。返事は読まない */
        if (navigator.sendBeacon) {
          navigator.sendBeacon(SINK.url, new Blob([body], {type: 'text/plain'}));
        } else {
          fetch(SINK.url, {method: 'POST', mode: 'no-cors', keepalive: true,
                           headers: {'Content-Type': 'text/plain'}, body: body});
        }
      } catch (e) { /* 記録で画面を止めない */ }
    }

    function ask(text) {
      if (!text || !window.UPC) return;
      var a = window.UPC.answer(text, ctx);
      me(text); bot(a);
      track(a);
      sink(text, a);
      turns.push({q: text, tier: a.tier, intent: a.intent,
                  product: ctx ? ctx.product : '', at: Date.now()});
      save(turns);
      paintScope();                   // 話す相手が変わったら、その場で出し直す
      chips.innerHTML = '';           // 一度聞かれたら、入口のチップは畳む
    }

    /* いまの話の帯にあるボタンも同じ扱い（ログの外なので、別に拾う） */
    scope.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-ask]');
      if (b) ask(b.getAttribute('data-ask'));
    });

    /* ボタンの「もう一度聞く」を拾う（吹き出しは後から増えるので窓ごと見る） */
    log.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var b = e.target.closest('[data-ask]');
      if (b) { ask(b.getAttribute('data-ask')); return; }
      /* ★買う一歩を後押しする＝窓を閉じて、サイズと色を選ぶところへお連れする。
         ⚠️ 目印はテーマの実物から探す（variant-selects / 購入フォーム）。
            見つからないときは追随している購入バーへ。それも無ければ何もしない */
      /* ★カートへ入れる。**押した瞬間に二度押しできないようにする**（重複投入が怖い） */
      var ct = e.target.closest('[data-cart]');
      if (ct) {
        if (ct.disabled) return;
        ct.disabled = true;
        var was = ct.textContent;
        ct.textContent = 'お入れしています…';
        /* ★押す前の覆いを控えておく＝**あとから出たものだけ**を知らせと見なす */
        var coversBefore = bodyCovers();
        fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({items: [{id: ct.getAttribute('data-cart'),
                                         quantity: 1}]})
        }).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        }).then(function () {
          ct.textContent = '✓ カートに入れました';
          log.appendChild(botTurn(
            '<p class="upc-lead">カートにお入れしました。</p>'
            + '<div class="upc-acts"><a class="upc-cta" href="/cart">カートを見る</a>'
            + '<button class="upc-sub" type="button" data-ask="ほかのものも見せてください">'
            + 'お買い物を続ける</button></div>'));
          showLatest();
          /* ★入ったらこちらは引っ込む＝窓が2つ並ばない（260809 Take） */
          closeAfterAdd(coversBefore);
        }).catch(function () {
          /* ⚠️ 入らなかったときは**入ったふりをしない**。選ぶところへお連れする */
          ct.disabled = false;
          ct.textContent = was;
          log.appendChild(botTurn(
            '<p class="upc-lead">うまくお入れできませんでした。</p>'
            + '<div class="upc-acts">'
            + '<button class="upc-cta" type="button" data-pick="1">'
            + 'サイズと色を選ぶ</button></div>'));
          showLatest();
        });
        return;
      }
      var pk = e.target.closest('[data-pick]');
      if (pk) {
        var host = document.querySelector(
          'variant-selects, variant-radios, .product-form__input,'
          + ' form[action*="/cart/add"], .sticky-footer-container');
        close();
        if (host) {
          host.scrollIntoView({block: 'center'});
          var focusable = host.querySelector('input,select,button');
          if (focusable && focusable.focus) focusable.focus({preventScroll: true});
        }
        return;
      }
      var d = e.target.closest('[data-diag]');
      if (d) {
        var host = document.querySelector(d.getAttribute('data-diag'));
        if (host) {
          close();
          host.scrollIntoView({block: 'center'});
          host.click();
        } else {
          var p = window.UPC.findProduct(turns.length ? turns[turns.length - 1].q : '');
          location.href = p ? ('/products/' + p.h) : '/collections/all';
        }
      }
    });

    /* 続きから始める。初めての人には呼びかけを出す */
    if (turns.length) {
      var last = turns[turns.length - 1];
      /* ⚠️ 前回が「こんにちは」や相槌だと、**それをお尋ねとして読み上げるのが変**。
         用件だったときだけ振り返る（260809・Take） */
      var wasTopic = last.intent && last.intent.indexOf('あいさつ') < 0
                     && last.intent.indexOf('相槌') < 0
                     && last.intent.indexOf('お礼') < 0;
      /* ★カートの面では、前回の話に戻さない。**会計の話から始める** */
      if (ctx && ctx.at === 'cart') {
        log.appendChild(botTurn('<p class="upc-lead">お会計の前に、'
          + '気になることがあればどうぞ。</p>'));
      } else if (wasTopic) {
        log.appendChild(botTurn('<p class="upc-lead">おかえりなさい。</p><p>前回は「'
          + esc(last.q.slice(0, 24))
          + '」のお尋ねでした。続きからでも、別のことでもどうぞ。</p>'));
      } else {
        log.appendChild(botTurn('<p class="upc-lead">おかえりなさい。</p>'
          + '<p>お探しのものを、ご一緒にお選びしますね。</p>'));
      }
    } else {
      greet();
    }

    /* ★はじめの一言は、**いまいる面のもの**にする（260809・Take「対話を消すと、
       そのページに該当する対話からリスタートできる様に」）。
       消したときも、はじめて開いたときも、同じここを通る */
    function greet(head) {
      var lead = head || '';
      if (ctx && ctx.at === 'cart') {
        log.appendChild(botTurn('<p class="upc-lead">' + lead + 'お会計の前に、'
          + '気になることがあればどうぞ。</p>'));
      } else if (pageHandle) {
        log.appendChild(botTurn('<p class="upc-lead">' + lead + 'この一枚のこと、'
          + 'なんでもお尋ねくださいね。</p>'));
      } else {
        log.appendChild(botTurn('<p class="upc-lead">' + lead
          + 'お買い物のことなら、なんでも聞いてくださいね。</p>'));
      }
    }
    /* 入口は、いまいる場所で変える。**買う前の相談を前に出す** */
    var ENTRY = {
      /* ★「着こなしシーン」＝どういうところに着ていけるか／「着用・コーデ例」＝
         何と合わせるか＋着ている写真。**言葉で分けて、迷わせない**（260809・Take） */
      /* ★店員なら、まず**その一枚の魅力**を話す（260809・Take「商品の魅力が抜けてる」） */
      product: [['商品の魅力', 'この商品の魅力を教えてください'],
                ['サイズを選ぶ', 'サイズはどれがいいですか'],
                ['色を見る', '何色ありますか'],
                ['素材・透け感', '素材を教えてください'],
                ['着こなしシーン', 'どんなときに着られますか'],
                ['着用・コーデ例', '合わせ方を教えて'],
                ['いつ届く？', 'いつ届きますか']],
      /* ★カートの面は、**もう選び終わっている**。探しものの入口を出さない
         （260809・Take「カート画面でサイズを選ぶが出て…へん」）。
         出すのは、会計の前に引っかかるところだけ */
      cart: [['いつ届く？', 'いつ届きますか'],
             ['送料は？', '送料はいくらですか'],
             ['お支払い方法', '支払い方法を教えてください'],
             ['返品はできる？', '返品はできますか'],
             /* サイズ違いは**返品でなく交換**で解く方が多い（260809・Take） */
             ['交換はできる？', 'サイズを交換したいです']],
      /* ★トップは、**まだ用が決まっていない人**がいるところ（260809・Take「ふらっと
         ウィンドウショッピングしてる人向けの選択肢になってない」）。
         「二の腕」「汗」「きちんと見え」は**もう困りごとが決まっている人**の言葉なので、
         受ける→伺う→1点お出しする道を前に出し、困りごとは1つだけ残す */
      other: [['Up selectについて', 'Up selectってどんなお店ですか'],
              ['合う一枚を選んで', '似合うものを見せてください'],
              ['似合う色から', 'カラー診断をお願いします'],
              ['人気のもの', '人気のものはどれですか'],
              ['お出かけ着に', 'お出かけに着たいです'],
              ['ふだん着に', 'ふだん着に着たいです'],
              ['いつ届く？', 'いつ届きますか']]
    };
    var where = pageHandle ? 'product'
              : (/\/cart|\/checkout/.test(location.pathname) ? 'cart' : 'other');
    /* ⚠️ 一度聞かれると畳む（458行）ので、**消したときは出し直す**。
       出し直さないと、リセットしたのに押すものが1つも無い画面になる */
    function paintEntry() {
      chips.innerHTML = '';
      ENTRY[where].forEach(function (x) {
        var c = el('button', 'upc-chip', esc(x[0]));
        c.type = 'button';
        c.addEventListener('click', function () { ask(x[1]); });
        chips.appendChild(c);
      });
    }
    paintEntry();

    panel.querySelector('.upc-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var i = panel.querySelector('.upc-input');
      var v = i.value.trim();
      i.value = '';
      ask(v);
    });
    panel.querySelector('.upc-forget').addEventListener('click', function () {
      /* ★消したあとに「消しました。」だけ出すと、そこから何ができるか分からなくなる
         （260809・Take）。**はじめのあいさつに戻す**＝入口のボタンがまた出る。
         ⚠️ カルテ（ctx.me）も一緒に捨てる。消したのに前の場面が残っていては困る */
      /* ⚠️ ここで `ask('こんにちは')` を投げていたため、商品ページで消しても
         **店じゅうの話（合う一枚を選んで…）から始まっていた**（260809・Take）。
         いまいる面のはじめの一言に戻す＝入口のボタンもその面のものが残る */
      /* ★消す範囲を、**ぜんぶ**にそろえる（260809・Take「選択アイテムは残るから、
         人によってやり取りを消す範囲がぶれそう。アイテムも含めてリセットするか」）。
         会話・カルテ・話に出ていた商品・帯の「いまの話」まで捨てて、
         **いまいるページの話**に戻す。⚠️ 帯を塗り直さないと、消したのに
         前の商品の名前が残って見える */
      /* ⚠️「消しました。」は機械的でハルメクらしくない（260809・Take）。
         お店の人の言い方にする＝**やり直しをこちらから引き受ける** */
      forget(); turns = []; log.innerHTML = '';
      ctx = window.UPC.newCtx(pageHandle, collHandle);
      /* ⚠️ 立ち上げのとき（193-195行）と**同じ見分け方**にする。ここだけ別の書き方に
         すると、カートの面で消したときだけ話す相手が変わる */
      if (/^\/cart(\/|$)/.test(location.pathname)) ctx.at = 'cart';
      paintScope();
      paintEntry();
      greet('はじめからにしますね。');
      showLatest();
    });

    /* ── ひとりでに開いて話しかける ───────────────────── */
    var say = fab.querySelector('.upc-say'), i = 0, timer = null;
    var still = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* 呼びかけの幅は**その場で測る**。⚠️ 字数から目分量で決め打ちしていたため、
       「素材や色のことも」のときだけ下の小さな一行が右で切れていた（260808に実機で発覚）。
       長いのは本文でなく `AIがその場でお答えします` のほうなので、**両方を入れて測る**。 */
    function sayWidth(text) {
      var probe = el('span', 'upc-say', text + SUB);
      probe.style.cssText = 'position:absolute;visibility:hidden;left:-9999px;top:0';
      document.body.appendChild(probe);
      var w = Math.ceil(probe.getBoundingClientRect().width);
      probe.parentNode.removeChild(probe);
      /* 丸37 ＋ すき間9 ＋ 左の余白9 ＋ 右の余白16 ＋ 枠2 */
      return w + 73;
    }

    /* 面ごとに呼びかけを変える。カートは**買う直前の心配ごと**だけ */
    var LINES = (where === 'cart') ? SAYS_CART : SAYS;
    function tick() {
      var s = LINES[i % LINES.length]; i++;
      say.innerHTML = s + SUB;
      fab.style.setProperty('--upc-w',
        Math.min(sayWidth(s), innerWidth - 32) + 'px');
      fab.classList.add('upc-open');
      setTimeout(function () {
        if (!panel.classList.contains('upc-shown')) fab.classList.remove('upc-open');
      }, CY * 0.5);
    }
    /* ★もう見ていただいた方には、**丸だけ**を出す（ページを移るたびの繰り返しをやめる）。
       ⚠️ 丸そのものは消さない＝聞きたくなったときの入口は、いつでもそこにある */
    if (sayQuiet()) {
      say.innerHTML = LINES[0] + SUB;      /* 幅は持たせておく（開いたときの形が崩れない） */
      fab.style.setProperty('--upc-w',
        Math.min(sayWidth(LINES[0]), innerWidth - 32) + 'px');
    } else if (!still) {
      tick();
      timer = setInterval(function () {
        if (panel.classList.contains('upc-shown')) return;
        if (i >= LINES.length) {           /* ひと回りしたら、そこでおしまい */
          clearInterval(timer); timer = null;
          fab.classList.remove('upc-open');
          markSaySeen();
          return;
        }
        tick();
      }, CY);
    } else {
      say.innerHTML = LINES[0] + SUB;
      fab.style.setProperty('--upc-w',
        Math.min(sayWidth(LINES[0]), innerWidth - 32) + 'px');
      fab.classList.add('upc-open');
      markSaySeen();
    }

    function open() {
      panel.classList.add('upc-shown');
      fab.style.display = 'none';
      if (timer) { clearInterval(timer); timer = null; }
      /* 開いていただけた＝もうご存じ。次の面から呼びかけは控える */
      markSaySeen();
      paintScope();
      // 開き直したときも同じ＝前回のお尋ねから見える（下端から始めない）
      showLatest();
    }
    function close() {
      panel.classList.remove('upc-shown');
      fab.style.display = '';
      fab.classList.remove('upc-open');
    }

    /* ★カートに入れたら、お店の知らせと窓が2つ並ぶ（260809 Take「チャットを閉じて欲しい」）。
       だから**入った時点ですぐ閉じる**。待ってから閉じると、その間ずっと2つ並ぶ。
       実測＝お店の知らせ `#pdps-added` は body の直下に出るが、**出るまで約1.2秒かかる**
       （260807に作ったPDPシートの知らせ。素の fetch では約0.3秒だった＝面と経路で変わる）。
       ⚠️ **知らせが出ない面もありうる**。そのときお客様は入ったかどうか分からないので、
          3秒見て何も出なければ**丸のふきだしで「カートにお入れしました」と言う**。
       ⚠️ 名前で決め打ちしない＝**body直下に、あとから出た大きな覆い**で見る。 */
    function bodyCovers() {
      var out = [], k = document.body.children;
      for (var i = 0; i < k.length; i++) {
        var e = k[i];
        if (e === panel || e === fab) continue;
        var cs = getComputedStyle(e);
        if (cs.position !== 'fixed' && cs.position !== 'absolute') continue;
        if (cs.visibility === 'hidden' || cs.display === 'none' || cs.opacity === '0') continue;
        var b = e.getBoundingClientRect();
        if (b.width >= 200 && b.height >= 150) out.push(e);
      }
      return out;
    }
    function closeAfterAdd(before) {
      close();
      var n = 0;
      var iv = setInterval(function () {
        var now = bodyCovers();
        for (var i = 0; i < now.length; i++) {
          if (before.indexOf(now[i]) < 0) { clearInterval(iv); return; }
        }
        /* 1.8秒。実測＝商品ページの知らせは**閉じた0.6秒後**に出た。
           長く待つと、知らせの出ない面（コレクション等）で黙る時間が延びるだけ */
        if (++n < 18) return;
        clearInterval(iv);
        /* 知らせが出なかった＝こちらで言う。押せば窓が開いて、記録も残っている */
        if (panel.classList.contains('upc-shown')) return;
        var msg = 'カートにお入れしました';
        say.innerHTML = msg + SUB;
        fab.style.setProperty('--upc-w',
          Math.min(sayWidth(msg), innerWidth - 32) + 'px');
        fab.classList.add('upc-open');
      }, 100);
    }
    fab.addEventListener('click', open);
    panel.querySelector('.upc-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('upc-shown')) close();
    });

    window.__upcAsk = ask;      // 実機で確かめるとき用
    window.__upcTick = tick;    // 呼びかけを次へ送る（切れていないかを撮る）
  });
})();
